import { render, staticRenderFns } from "./TripComments.vue?vue&type=template&id=4e2906de&scoped=true&"
import script from "./TripComments.vue?vue&type=script&lang=js&"
export * from "./TripComments.vue?vue&type=script&lang=js&"
import style0 from "./TripComments.vue?vue&type=style&index=0&id=4e2906de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2906de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
